<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Cliente"
          label-for="cliente"
          :label-cols="labelCols"
          horizontal>
          <b-input-group>
            <b-input-group-append 
                class="filter-search-icons" 
                @click="seleccionarCliente">
              <b-input-group-text>
                <i :class="{ 'fa fa-search': !cliente,
                              'fa fa-remove': cliente  }"></i>
              </b-input-group-text>
            </b-input-group-append>
            <b-form-input 
              id="cliente"
              :value="clienteNombre"
              readonly
              :state="clienteValido"
              type="text"/>
            <b-form-invalid-feedback id="clienteFeedback">
              {{ clienteInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Pje.Participación"
          label-for="pjeParticipacion"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="pjeParticipacion"
            v-model.trim="$v.pjeParticipacion.$model" 
            :state="pjeParticipacionValido"
            type="number">
          </b-form-input>
          <b-form-invalid-feedback id="pjeParticipacionFeedback">
            {{ pjeParticipacionInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="actualizarCliente">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import { required, decimal } from 'vuelidate/lib/validators';

export default {
  name: 'VendedorCliente',
  components: {
    appSearchCliente: SearchCliente,
  },
  data: () => {
    return {
      cliente: null,
      pjeParticipacion: 0,

      clienteValido: null,
      clienteInvalidoMsj: '',
      pjeParticipacionValido: null,
      pjeParticipacionInvalidoMsj: '',

      labelCols: 3
    }
  },
  computed: {
    clienteId() {
      if (this.cliente) {
        if (this.cliente.id) {
          return this.cliente.id;
        }
      }
      return 0;
    },
    clienteNombre() {
      if (this.cliente) {
        if (this.cliente.nombre) {
          return this.cliente.nombre;
        }
      }
      return null;
    },
  },  

  created() {
  },  
  methods: {
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();
      this.cliente = cliente;

      this.clienteValido = null;
      this.clienteInvalidoMsj = '';
    },
    actualizarCliente() {
      let actualizar = true;

      this.$v.$touch();

      let errorCliente = true;
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            errorCliente = false;
          }
        }
      }
      if (errorCliente) {
        this.clienteValido = false;
        this.clienteInvalidoMsj = "Debe seleccionar el cliente correspondiente.";
        actualizar = false;
      }

      if (this.$v.pjeParticipacion.$error) {
        this.pjeParticipacionValido = false;
        if (!this.$v.pjeParticipacion.decimal) {
          this.pjeParticipacionInvalidoMsj = 'El porcentaje de participación debe ser un valor numérico.';
        }      
        actualizar = false;
      } else {
        this.pjeParticipacionValido = null;
        this.pjeParticipacionInvalidoMsj = '';
      }

      // console.log(actualizar);

      if (actualizar) {
        let params = {
          cliente: this.cliente,
          pjeParticipacion: this.pjeParticipacion
        }
        this.$emit('actualizarCliente', params)
      }
    },
    cancelar() {
      this.$emit('cancelar')
    }
  },
  validations: {
    pjeParticipacion: {
      decimal
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
